import { createContext } from "react";
import DEFAULT_CONTEXT from "./defaults";

export default createContext(DEFAULT_CONTEXT);
